import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  unit?: string;
  delta?: { value: string; direction: 'up' | 'down' | 'flat' };
  /** Kratko objasnjenje ispod brojke — za mjere cije ime nije samo po sebi jasno. */
  hint?: string;
  className?: string;
}

const DELTA_TONE = {
  up: 'text-success-dark',
  down: 'text-danger',
  flat: 'text-ink-muted',
};

export function StatTile({ label, value, unit, delta, hint, className }: StatTileProps) {
  return (
    <div
      className={cx(
        'rounded-lg border border-line-subtle bg-surface p-4 shadow-card',
        className,
      )}
    >
      <p className="eyebrow mb-2">{label}</p>
      {/* Brojka u Jostu, ne u serifu — vidi komentar uz `stat` u `@st/tokens`. */}
      <p className="font-body text-[32px] font-semibold leading-none tracking-[-0.5px] text-ink tabular-nums">
        {value}
        {unit && <span className="ml-1 font-body text-[13px] text-ink-muted">{unit}</span>}
      </p>
      {delta && (
        <p className={cx('mt-2 text-[12px]', DELTA_TONE[delta.direction])}>{delta.value}</p>
      )}
      {hint && <p className="mt-2 text-[12px] leading-snug text-ink-muted">{hint}</p>}
    </div>
  );
}
